/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TemplateContentFiles {
    getFixupPrototypeFunction() { return TemplateContentFiles.fixupPrototype; }

    static newInstance(model: Partial<TemplateContentFiles>): TemplateContentFiles {
        let obj = Object.assign(new TemplateContentFiles(), model);
        TemplateContentFiles.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TemplateContentFiles>): TemplateContentFiles {
        if (!model) return null;
        return TemplateContentFiles.newInstance(<TemplateContentFiles> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TemplateContentFiles) {
        if (!obj) return;

        models.TemplateContentFiles.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TemplateContentFiles): boolean {
        Object.setPrototypeOf(obj, TemplateContentFiles.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.content) {
            models.TemplateContentFilePiece.fixupPrototype(this.content);
        }
        if (this.variable) {
            models.TemplateContentFilePiece.fixupPrototype(this.variable);
        }
        if (this.output) {
            models.TemplateContentFilePiece.fixupPrototype(this.output);
        }
        if (this.files) {
            for (let val of this.files) {
                models.TemplateContentFilePiece.fixupPrototype(val);
            }
        }
    }

    /**
     * Main template file, e.g. main.tf
     */
    content: models.TemplateContentFilePiece;

    /**
     * Variables file, e.g. variables.tf
     */
    variable: models.TemplateContentFilePiece;

    /**
     * Outputs file, e.g. output.tf
     */
    output: models.TemplateContentFilePiece;

    /**
     * Additional files, if any
     */
    files: Array<models.TemplateContentFilePiece>;

}
